/*! error-report.js */

const GTM = window.BVP_GTM;

/**
 * @class ErrorReport
 */
class ErrorReport {
    /**
     * @static
     * @param {Log} logger
     * @param {...object} logArguments
     */
    static recordGenericError(logger, ...logArguments) {
        const stringifiedArguments = stringifyArguments(logArguments);
        logger.error.apply(logger, logArguments);
        GTM.trackError(GTM.errorTypes.GENERIC, `${ logger.label }: ${ stringifiedArguments }`);
    }

    /**
     * @static
     * @param {Log} logger
     * @param {...object} logArguments
     */
    static recordHLSError(logger, ...logArguments) {
        const stringifiedArguments = stringifyArguments(logArguments);
        logger.error.apply(logger, logArguments);
        GTM.trackError(GTM.errorTypes.HLS, `${ logger.label }: ${ stringifiedArguments }`);
    }

    /**
     * @static
     * @param {Log} logger
     * @param {string} url
     * @param {...object} logArguments
     */
    static recordLoadError(logger, url, ...logArguments) {
        const stringifiedArguments = stringifyArguments(logArguments);
        logger.error.apply(logger, logArguments);
        GTM.trackError(GTM.errorTypes.LOAD, `${ logger.label }: ${ stringifiedArguments }`, url);
    }

    /**
     * @static
     * @param {Log} logger
     * @param {string} url
     * @param {...object} logArguments
     */
    static recordAdError(logger, url, ...logArguments) {
        const stringifiedArguments = stringifyArguments(logArguments);
        logger.error.apply(logger, logArguments);
        GTM.trackError(GTM.errorTypes.AD, `${ logger.label }: ${ stringifiedArguments }`, url);
    }
}

/**
 * @private
 * @param {object[]} args
 * @returns {string}
 */
function stringifyArguments(args) {
    return args.reduce((tmp, arg) => `${ tmp } ${ stringifyArgument(arg) }`, "").trim();
}

/**
 * @private
 * @param {object} arg
 * @returns {string}
 */
function stringifyArgument(arg) {
    // NOTE: we try to handle the special case where the arg is an object
    //       that contains a message parameter (e.g. Error objects)
    return (arg && arg.message) ? arg.message : String(arg);
}

export default ErrorReport;
